import { ErrorActions, MessageActions } from 'common/constants/actions';

const initialState = {
  msg: {},
  errors: {},
  status: {},
  data: {},
  headers: {},
  fullError: {},
  message: false,
  password: [],
  passwordFail: [],
};

export default function ShowErrors(state = initialState, action) {
  switch (action.type) {
    case ErrorActions.GET_ERRORS:
      return {
        ...state,
        msg: action.payload,
        status: action.payload,
        errors: action.payload,
      };
    case MessageActions.CREATE_MESSAGE:
    case MessageActions.UPDATE_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };
    case ErrorActions.ALL_ERRORS:
      if (action.payload?.message?.data) {
        return {
          msg: action.response,
          errors: action.response,
          status: action.response.status,
          data: action.payload.data,
          headers: action.payload.headers,
        };
      }
      return {
        ...state,
        status: action.payload?.status,
        data: action.payload?.data,
        headers: action.payload?.headers,
        msg: action.payload,
        errors: action.payload,
        fullError: action.payload,
      };
    case ErrorActions.CLEAR_ERRORS:
      return {
        ...state,
        msg: {},
        errors: {},
        status: null,
        data: {},
        headers: {},
        fullError: {},
      };
    case ErrorActions.LOG_ERRORS:
      return {
        ...state,
        error_logged: true,
        msg: {},
        errors: {},
        status: {},
        data: {},
        headers: {},
        fullError: {},
        message: false,
        password: [],
        passwordFail: [],
      };
    case ErrorActions.CLEAR_ALL:
      return {
        ...state,
        msg: {},
        errors: {},
        status: {},
        data: {},
        headers: {},
        fullError: {},
        message: false,
        password: [],
        passwordFail: [],
      };
    default:
      return state;
  }
}
